import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../../../reducers/types";
import { actions } from "../../../../actions";
import {
  getAdultsCount,
  getChildrenCount,
  getFromDate,
  getLocation,
  getPetsCount,
  getStayType,
  getUntilDate,
  getVacationRentalsLocation,
} from "../../../../reducer";
import { MobileCalendarPickerModal } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    searchLocation: getLocation(state),
    searchVacationRentalsLocation: getVacationRentalsLocation(state),
    adultsCount: getAdultsCount(state),
    childrenCount: getChildrenCount(state),
    petsCount: getPetsCount(state),
    stayType: getStayType(state),
  };
};

const mapDispatchToProps = {
  setFromDate: actions.setFromDate,
  setUntilDate: actions.setUntilDate,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileCalendarPickerModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileCalendarPickerModal = withRouter(
  connector(MobileCalendarPickerModal)
);
